"use client";

import React from "react";
import { Instagram, MessageCircle, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ArtistHero() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="artisthero" className="dark relative min-h-screen flex items-center justify-center overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698889/img/WhatsApp Image 2026-06-09 at 14.02.35.jpg" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698889/img/WhatsApp Image 2026-06-09 at 14.02.35.jpg-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698889/img/WhatsApp Image 2026-06-09 at 14.02.35.jpg-wvc-sizes" alt="Hardrock Tattoo Studio Background" className="w-full h-full object-cover" loading="lazy" />
        <div className="absolute inset-0 bg-background/90" />
      </div>

      {}
      <div className="relative z-10 flex flex-col items-center text-center px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto py-24">
        
        {}
        <div ref={ref1} className={`flex flex-col items-center transition-all duration-1000 ease-out ${isVisible1 ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <Separator className="w-16 h-[2px] bg-primary mb-8" />
          <span className="font-mono text-primary tracking-[0.3em] uppercase text-sm sm:text-base mb-6 font-semibold">
            Artist
          </span>
        </div>

        {}
        <div ref={ref2} className={`flex flex-col items-center transition-all duration-1000 delay-200 ease-out ${isVisible2 ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <h2 className="font-default italic text-6xl sm:text-7xl md:text-8xl text-foreground mb-6 font-medium tracking-tight">
            George
          </h2>
          <h1 className="font-default text-4xl sm:text-5xl md:text-6xl text-foreground mb-10 font-bold leading-tight drop-shadow-lg">
            Where Ink Becomes Legend
            <span className="block text-xl sm:text-2xl md:text-3xl text-muted-foreground font-normal mt-6 tracking-wide">
              · Paphos Cyprus ·
            </span>
          </h1>
        </div>

        {}
        <div ref={ref3} className={`flex flex-col items-center w-full transition-all duration-1000 delay-400 ease-out ${isVisible3 ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <p className="font-mono text-lg sm:text-xl text-foreground/90 mb-12 tracking-widest">
            TEL: +357 94 043514
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 w-full max-w-2xl">
            <Button asChild size="lg" className="w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90 text-lg h-14 px-8 rounded-md shadow-lg shadow-primary/20 transition-transform hover:scale-105">
              <Link to="https://instagram.com/hardrockcytattoo" newTab>
                <Instagram className="mr-2 size-6" />
                Instagram
              </Link>
            </Button>
            
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto border-border bg-background/20 backdrop-blur-sm text-foreground hover:bg-background/40 text-base h-14 px-8 rounded-md transition-colors">
              <Link to="https://wa.me/35794043514" newTab>
                <MessageCircle className="mr-2 size-5" />
                WhatsApp
              </Link>
            </Button>
            
            <Button asChild variant="ghost" size="lg" className="w-full sm:w-auto text-foreground hover:bg-background/20 text-base h-14 px-8 rounded-md transition-colors">
              <Link to="tel:+35794043514">
                <Phone className="mr-2 size-5" />
                Call Now
              </Link>
            </Button>
          </div>
        </div>

      </div>
    </section>;
}